<div class="justup-dialog-large prod-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    Productivité moyenne — depuis le 1er janvier
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="basic" icon="precision_manufacturing"
                     title="Lignes"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">{{ stats().total }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="valid" icon="trending_up"
                     title="Score moyen"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">{{ stats().avgScore | number:'1.0-0' }}%</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="emoji_events"
                     title="Meilleure ligne"
                     style="flex: 1; min-width: 160px">
        <div content class="flex-col gap-2">
          <span class="body-1" style="font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ stats().topLabel }}
          </span>
          <span class="tiny" style="opacity: 0.7">{{ stats().topScore | number:'1.0-0' }}%</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display"
                     [color]="stats().lowPerf > 0 ? 'error' : 'valid'"
                     icon="warning"
                     title="Sous-performance"
                     matTooltip="Lignes avec un score poste ≤ 2 (étoiles)"
                     style="flex: 1; min-width: 160px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().lowPerf }}</span>
          <span class="tiny" style="opacity: 0.7">
            ligne{{ stats().lowPerf > 1 ? 's' : '' }}
          </span>
        </div>
      </vl-radio-card>
    </div>

    <!-- Filtre -->
    <div class="flex-row gap-8 align-center">
      <div class="grow"></div>
      <vl-input-search
        [(value)]="search"
        placeholder="Nom de la ligne…"
        style="min-width: 220px"
      />
    </div>

    <!-- Table -->
    <div class="prod-table-wrapper">
      <table class="prod-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('ligne')">
              Ligne
              @if (sortKey() === 'ligne') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable num" (click)="toggleSort('score')"
                matTooltip="Score moyen pondéré par les quantités produites depuis le 1er janvier">
              Score
              @if (sortKey() === 'score') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('score_poste')"
                matTooltip="Évaluation moyenne par poste (1 à 5)">
              Évaluation
              @if (sortKey() === 'score_poste') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of filtered(); track row.ligneDenomination) {
            <tr>
              <td>{{ row.ligneDenomination }}</td>
              <td class="num">
                <span [class.score-warn]="+row.score_poste <= 2"
                      [class.score-ok]="+row.score_poste > 2">
                  {{ row.score }}%
                </span>
              </td>
              <td>
                <div class="evaluation">
                  @if (+row.score_poste <= 2) {
                    <mat-icon class="on-warning">warning</mat-icon>
                  } @else {
                    @for (i of 5 | range; track i) {
                      @if (i + 1 <= +row.score_poste) {
                        <mat-icon class="on-warning2">star</mat-icon>
                      } @else {
                        <mat-icon class="on-disabled">star_border</mat-icon>
                      }
                    }
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="3" class="empty">{{ 'list.empty' | trans }}</td></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
